import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    color: hexToRGBA(TextColors.light, TextOpacities.light2),

    '& $sortByButton': {
      '&.MuiButton-root': {
        color: TextColors.light,
      },
    },

    '& $menuIcon': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    color: hexToRGBA(TextColors.dark, TextOpacities.dark2),

    '& $sortByButton': {
      '&.MuiButton-root': {
        color: TextColors.dark,
      },
    },

    '& $menuIcon': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto',
      marginBottom: muiTheme.spacing(0.5),
    },
    label: {
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    mobileLabel: {
      [muiTheme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    value: {
      display: 'none',

      [muiTheme.breakpoints.up('md')]: {
        display: 'inline',
      },
    },
    sortByButton: {
      '&.MuiButton-root': {
        marginLeft: muiTheme.spacing(0.5),
      },
    },
    menuIcon: {},
  }),
  { name: 'ElasticComponentSortBy' },
);

export default useStyles;
